export default ({ pnr, actionType, spid, storefront }) => {
  return {
    event: 'CorporateSeatMap',
    pnr: pnr,
    actionType: actionType,
    spid: spid ? spid : 'NA',
    storefront: storefront,
  };
};